import { useContext } from "react";

import { ModalContext } from "@/contexts/ModalsContext";

import styles from "@/styles/modals.module.scss";

interface ErrorProps {
    errMsg: string | null;
};

const ErrorModal = ({ errMsg }: ErrorProps) => {
    const { modalState: { error }, dispatchModal } = useContext(ModalContext);

    if (!error) return null;

    const handleToggleErrorModal = () => {
        dispatchModal({ type: "TOGGLE_ERROR" });
    };

    return (
        <div className={styles["modal-backdrop"]}>
            <div className={styles["modal"]}>
                <p>{errMsg}</p>
                <button onClick={handleToggleErrorModal} className={styles["modal-btn"]}>OK</button>
            </div>
        </div>
    )
};

export default ErrorModal;
